export default __webpack_public_path__ + "static/media/icon-books.a7ee1c19.svg";